// extracted by mini-css-extract-plugin
var _1 = "DefaultCell_cell__AIUfP";
export { _1 as "cell" }
